export const useValidation = () => {
  const validateField = ({ FieldName, value, otherValues, country }) => {
    let errorFlag = false;
    let error = "";

    // Switch on field name and validate accordingly
    switch (FieldName) {
      // case "FirstName":
      // case "LastName":
      case "City":
      // case "Denominazione":
      // case "Nome":
      // case "Cognome":
      case "Ruolo":
      // case "denominazione":
      case "comune":
      case "city":
      case "drugDescription":
      case "Dosage":
        var data =
          FieldName === "FirstName"
            ? "Nome"
            : FieldName === "LastName"
            ? "CogNome"
            : FieldName === "City" || FieldName === "city"
            ? "Citta"
            :  FieldName === "drugDescription"
            ? "Descrizione Estesa"
            ?  FieldName === "Dosage" :
              "Dosaggio"
            : FieldName;
        if (value === "") {
          errorFlag = true;
          error = `${data} richiesto`;
        } else if (!/^[a-zA-Z\s]+$/.test(value)) {
          errorFlag = true;
          if (value?.length < 2) {
            error = `${data} dovrebbe avere almeno 2 caratteri`;
          } else {
            error = `${data} dovrebbe includere solo lettere.`;
          }
        } else if (value?.length > 40) {
          errorFlag = true;
          error = `${data} dovrebbe essere al massimo di 40 caratteri`;
        }
        break;
      
      case "FirstName":
      case "LastName":
      case "Nome":
      case "Cognome":
      case "Denominazione":
      case "denominazione":
        var data =
          FieldName === "FirstName"
            ? "Nome"
            : FieldName === "LastName"
            ? "CogNome"
            : FieldName
        // if (!/^[a-zA-Z\s]+$/.test(value)) {
        if (value === "") {
          errorFlag = true;
          error = `${data} richiesto`;
        } else if (!/^[a-zA-Z0-9\s]+$/.test(value)) {
          errorFlag = true;
          if (value?.length < 2) {
            error = `${data} dovrebbe avere almeno 2 caratteri`;
          }
        }
        else if (value?.length > 40) {
          errorFlag = true;
          error = `${data} dovrebbe essere al massimo di 40 caratteri`;
        }
        break;


      case "Email":
      case "UserEmail":
        const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        const trimmedValue = value?.trim();

        if (trimmedValue === "") {
          errorFlag = true;
          error = `Inserisci le tue credenziali per accedere al sistema`;
        } else if (!emailRegex.test(trimmedValue)) {
          errorFlag = true;
          error = `Indirizzo email non valido`;
        }

        break;
      case "newPassword":
      case "passwordHash":
      case "UserPassword":
      case "UserConfirmPassword":
        const passwordRules =
          /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!*]).*$/;
        if (value === "") {
          errorFlag = true;
          error = `È richiesta la ${FieldName}`;
        } else if (
          !passwordRules.test(value) &&
          FieldName !== "UserConfirmPassword"
        ) {
          errorFlag = true;
          error = `La nuova password deve essere lunga almeno 8 caratteri e contenere almeno una lettera minuscola, una maiuscola, un numero e un carattere speciale`;
        } else if (
          FieldName === "UserConfirmPassword" &&
          value !== otherValues?.UserPassword
        ) {
          errorFlag = true;
          error = "Le password non coincidono";
        }
        break;
      case "PhoneNumber":
      case "HospitalNumber":
      case "PatientPhoneNumber":
        const phoneWithoutCode = value?.replace(`+${country?.dialCode}`, "");
        const requiredLength = country?.format?.match(/\d/g)?.length || 10;
        if (!value || value === "") {
          errorFlag = true;
          error = `${"Contatto"} is required`;
        }
        if (phoneWithoutCode?.length < requiredLength) {
          return {
            errorFlag: true,
            error: `${"Contatto"} deve avere almeno ${requiredLength} cifre`,
          };
        }

        return { errorFlag: false, error: "" };
        break;
      
      case "cap":
        const capCheck = /^\d+$/;
        if ((value !== "" && value !== null) && !capCheck.test(value)) {
            errorFlag = true;
            error = `cap non valido`;
        }
      break;
      
      case "otp":
        if (!value || value?.length !== 6) {
          errorFlag = true;
          error = `Compila tutti i campi`;
        }
        break;
        case "FiscalCode":
          case "fiscalCode":
            const fiscalCodeCheck =
              /^[A-Z]{6}[0-9]{2}[A-Z]{1}[0-9]{2}[A-Z]{1}[0-9]{3}[A-Z]{1}$/;
            if ((value != "" && value!== null) && !fiscalCodeCheck.test(value)) {
              errorFlag = true;
              error = `Formato del codice fiscale non valido`;
            }

        break;
        case "pickup":
          case "notifications":
          case "remainder":
          case "pharmacyAddress":
          case "statusbtn":
          case "calendar":
          case "productType":
          case "drugClass"  :
            if (value == "") {
    
          errorFlag = true;
          error = `È richiesta la ${FieldName}`;
        }
        break;
      case "ministerialId":
        const idRegex = /^\d+$/;
        if (value == "") {
          errorFlag = true;
          error = `È richiesta la ${FieldName}`;
        } else if (value !== "" && !idRegex.test(value)) {
          errorFlag = true;
          error = `Fornire solo numeri`;
        }
        break;
      case "Province":
      case "provincia":
        let regexAlpha = "/^[a-zA-Z]+$/";
        if (value == "") {
          errorFlag = true;
          error = `È richiesta la ${FieldName}`;
        } else if (value?.length != 2 || !/^[a-zA-Z]+$/.test(value)) {
          errorFlag = true;
          error = `Dimostra i due caratteri esatti dell'alfabeto ${FieldName}`;
        }
        break;
      case  "Address":
        case "indirizzo":
        case "description":
        case "Descrizione":
        case "Tipologia":
        case "price":
          let updatedData=FieldName==="price" ? "Prezzo" : FieldName==="description" ? "Descrizione" : FieldName
        if (value == "") {
          errorFlag = true;
          error = `È richiesta la ${updatedData}`;
        }
        break;
        case "vat":
          // NOT AREQUIRED FIELD
           if (FieldName=='vat' && value?.length>11 && !/^\d{11}$/.test(value)) {
            errorFlag = true;
            error = `Fornisci esattamente 11 numeri ${FieldName}`;
          }
          break;
          case "aic":
            if(value === "" ){
              errorFlag = true;
              error = `È richiesta la ${FieldName}`;
            }
            else if(FieldName==='aic' && value?.length>10 && !/^\d{10}$/.test(value)){
              errorFlag = true;
              error = `Consenti solo 10 cifre e deve essere un numero ${FieldName}`;
            }
            break
        case  "drugCompanyName":
          var numalpha=/^[a-zA-Z0-9]+$/
          var data =FieldName === "drugCompanyName" ? "Ragione Sociale Azienda" : FieldName
          if (value== " ") {
            errorFlag = true;
            error = `È richiesta la ${data}`;
          }else if(!numalpha.test(value)){
            errorFlag = true;
            error = `${data} deve contenere solo lettere e numeri, senza caratteri speciali.`;
          }
          break
          case "umr":
          case  "daysAlert":
          case "hoursAlert":
            var num=/^[0-9]+$/
            var data = FieldName === "daysAlert" ? "Numero di giorni allerta" : FieldName === "hoursAlert" ? "Numero di ore di allerta assunzione" : FieldName ==="umr" ? "UMR" : FieldName
            if (value== " ") {
              errorFlag = true;
              error = `È richiesta la ${data}`;
            }else if(!num.test(value)){
              errorFlag = true;
              error = `${data} deve contenere solo lettere e numeri, senza caratteri speciali.`;
            }
            break
      default:
        errorFlag = false;
        error = "";
        break;
    }
    return { errorFlag, error };
  };

  return { validateField };
};

export default useValidation;
